<media-image [src]="data.currentImage.url"  size="original"></media-image>
<button class="close-button" mat-mini-fab (click)="close()">
    <mat-icon svgIcon="close"></mat-icon>
</button>